import { z } from "zod";
export const customerOrderNotificationHistoryV1Schema = z
    .object({
    physicalOrderId: z.string().min(1).max(240),
    coverage: z.literal("V2_LEDGER_ONLY_LEGACY_OUTCOMES_UNAVAILABLE"),
    deliveryObservations: z.enum([
        "CALLBACK_NOT_ACTIVATED",
        "CALLBACK_OBSERVATIONS_RECORDED",
        "NO_CALLBACK_OBSERVATION",
    ]),
    notifications: z
        .array(z
        .object({
        recordId: z
            .string()
            .regex(/^[a-f0-9]{64}$/)
            .optional(),
        kind: z.string().regex(/^[A-Z_]{1,80}$/),
        verifiedTransition: z.boolean().optional(),
        state: z.enum([
            "PROVIDER_ACCEPTED",
            "UNKNOWN",
            "FAILED_NOT_ACCEPTED",
            "DELIVERY_OBSERVED",
            "BOUNCE_OBSERVED",
            "COMPLAINT_OBSERVED",
        ]),
        updatedAt: z.string().datetime({ offset: true }),
        readObserved: z.literal(false),
        observations: z
            .object({
            acceptedAt: z.string().datetime({ offset: true }).nullable(),
            deliveredAt: z.string().datetime({ offset: true }).nullable(),
            bouncedAt: z.string().datetime({ offset: true }).nullable(),
            complainedAt: z.string().datetime({ offset: true }).nullable(),
            delayedAt: z.string().datetime({ offset: true }).nullable(),
            rejectedAt: z.string().datetime({ offset: true }).nullable(),
            renderingFailedAt: z.string().datetime({ offset: true }).nullable(),
        })
            .strict()
            .optional(),
    })
        .strict())
        .max(50),
    nextCursor: z.string().max(2048).nullable(),
})
    .strict();
//# sourceMappingURL=book-notification-history.js.map